import React, { useEffect, useState } from 'react'
import './NewHeader.css'
import { Button, Dropdown, Menu } from 'antd'
import { useSelector } from 'react-redux';
import { FaAngleDown } from "react-icons/fa6";
function NewHeader({setClick,setSales,setCurrentstaff,click}) {
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const userInfo = useSelector((state) => state.signUp.signUpDetails);


const handleattend = (com) => {
  const savedState = JSON.parse(sessionStorage.getItem("dashboardState")) || {};
 
        setClick(com)
        setSales('')
        setCurrentstaff('')
   
          const stateToSave = {
            attendance:savedState.attendance,
            salesDepartmentId:savedState.salesDepartmentId,
            currentStaffId:savedState.currentStaffId,
            click : com,
            empClick:savedState.empClick,
            sales:savedState.sales,
            currentStaff:savedState.currentStaff ,
            active:savedState.active ,
          };
          sessionStorage.setItem("dashboardState", JSON.stringify(stateToSave));
         
        
    }

    const vvx = [
        {
          key: '1',
          label: (
            <a className='atten-menu' onClick={() => handleattend('today')}>
              Todays View
            </a>
          ),
        },
        {
          key: '2',
          label: (
            <a className='atten-menu' onClick={() => handleattend('simple')}>
              Simple View
            </a>
          ),
        },
      ];
      const items: MenuProps['items'] = [
        {
          key: '1',
          label: (
            <a className='hed-menu'  onClick={() => handleattend('alert')}>
              Attend. Alerts
            </a>
          ),
        },
        {
          key: '2',
          label: (
            <a className='hed-menu'  onClick={() => handleattend('detail')}>
             Detailed Attend. History
            </a>
          ),
        },
        {
          key: '3',
          label: (
            <a className='hed-menu' onClick={() => handleattend('shift')} >
              Shift & locations
            </a>
          ),
        },
      ];
  return (
    <div>
         <div className='flex !mt-2 !mb-5'>
                <Button className='bg-[#4B8AEB] rounded-full h-[50px] shadow-none border-none !px-5 min-w-[125px] font-ProximaBold outline-none focus:outline-none' style={{backgroundColor: `${click === 'attenteam' ? '#4B8AEB' : '#E4EEFC'}`,color: `${click === 'attenteam' ? '#FFFFFF' : 'rgb(138, 163, 190)'}`}} onClick={() => handleattend('attenteam')}>Attend. Team(Admin)</Button>
                <Button className='bg-[#4B8AEB] rounded-full h-[50px] shadow-none border-none !px-5 min-w-[125px] font-ProximaBold !ml-3 outline-none focus:outline-none' style={{backgroundColor: `${click === 'orgdetail' ? '#4B8AEB' : '#E4EEFC'}`,color: `${click === 'orgdetail' ? '#FFFFFF' : 'rgb(138, 163, 190)'}`}} onClick={() => handleattend('orgdetail')}>Org. Details(Admin)</Button>
                <Button className='bg-[#4B8AEB] rounded-full h-[50px] shadow-none border-none !px-5 min-w-[125px] font-ProximaBold !ml-3 outline-none focus:outline-none' style={{backgroundColor: `${click === 'overview' ? '#4B8AEB' : '#E4EEFC'}`,color: `${click === 'overview' ? '#FFFFFF' : 'rgb(138, 163, 190)'}`}} onClick={() => handleattend('overview')}>Overview</Button>
                <Dropdown overlay={<Menu items={vvx} />} placement="bottomLeft">
                    <Button className='bg-[#4B8AEB] rounded-full h-[50px] shadow-none border-none !pl-5 !pr-4 min-w-[125px] font-ProximaBold !ml-3 outline-none focus:outline-none flex items-center justify-center' style={{backgroundColor: `${click === 'today' || click === 'simple' ? '#4B8AEB' : '#E4EEFC'}`,color: `${click === 'today' || click === 'simple' ? '#FFFFFF' : 'rgb(138, 163, 190)'}`}}><div className='flex items-center leading-none flex-col'>Attendance View
                    {(click === 'simple' || click === 'today') && ( <small className='block text-[rgba(255,255,255,.7)] text-[11px] leading-none mt-1'> {click === 'today' ? 'Today View' : 'Simple View'}</small>
                   )}  </div><FaAngleDown className='ml-2 text-xs' /></Button>
                </Dropdown>
                <Dropdown overlay={<Menu items={items} />} placement="bottomLeft">
                    <Button className='bg-[#4B8AEB] rounded-full h-[50px] shadow-none border-none !pl-5 !pr-4 min-w-[125px] font-ProximaBold !ml-3 outline-none focus:outline-none flex items-center justify-center' style={{backgroundColor: `${click === 'alert' || click === 'detail' || click === 'shift' ? '#4B8AEB' : '#E4EEFC'}`,color: `${click === 'alert' || click === 'detail' || click === 'shift' ? '#FFFFFF' : 'rgb(138, 163, 190)'}`}}><div className='flex items-center leading-none flex-col'>Attend. Daily Works
                    {(click === 'detail' || click === 'shift' ||  click === 'alert') && (<small className='block text-[rgba(255,255,255,.7)] text-[11px] leading-none mt-1'> {click === 'alert' ? 'Attend. Alerts' : 
    click === 'detail' ? 'Detailed Attend. History' :
    click === 'shift' ? 'Shift & Location' : ''}</small>
                    )}</div><FaAngleDown className='ml-2 text-xs' /></Button>
                </Dropdown>
               
            </div>
          
    </div>
  )
}

export default NewHeader